import { makeStyles } from 'tss-react/mui';

export default makeStyles<void, 'count'>({ name: 'Label' })((_, __, classes) => ({
    root: {
        display: 'flex',
        padding: '7px 12px',
        alignItems: 'center',
        gap: 8,
        borderRadius: 12,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        border: '1px solid transparent'
    },
    icon: {
        display: 'flex',
        ['& svg']: {
            width: 16,
            height: 16
        }
    },
    count: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    },
    _default: {
        color: '#232323',
        borderColor: '#ECECEC',
        background: 'transparent',
        [`& .${classes.count}`]: {
            color: '#8E8E8E'
        }
    },
    _danger_contained: {
        background: '#FF5342',
        borderColor: '#FF5342',
        color: '#FFEBED',
        [`& .${classes.count}`]: {
            color: '#FFEBED'
        }
    },
    _danger_outlined: {
        borderColor: '#F5726A',
        background: 'transparent',
        color: '#F5726A',
        [`& .${classes.count}`]: {
            color: '#F5726A'
        }
    },
    _compact: {
        padding: '4px 8px 4px 4px'
    }
}));
